<div style="overflow-y: auto; max-height: 90vh;">
    <div>
        <mat-dialog-actions>
            <Button mat-dialog-close mat-raised-button class="btn" style="margin-left: 80%;">
                Close
            </Button>
        </mat-dialog-actions>
    </div>
    <div>
        <h2 style="text-align: center; margin-top: 2%;">Update District Name</h2>
        <form [formGroup]="districtForm" (ngSubmit)="updateDistrict()">
            <div class="form-row">
                <mat-form-field style="width: 80%; margin-top: 3%; margin-left: 10%" appearance="outline">
                    <mat-label>District Name:*</mat-label>
                    <input type="text" matInput formControlName="districtname" required />
                </mat-form-field>
            </div>
            <div class="form-row">
                <mat-form-field style="width: 80%; margin-top: 3%; margin-left: 10%" appearance="outline">
                    <mat-label>Sequence Id:*</mat-label>
                    <input type="text" matInput formControlName="sequence_id" required />
                </mat-form-field>
            </div>
            <div class="form-row">
                <mat-form-field style="width: 80%; margin-top: 3%; margin-left: 10%" appearance="outline">
                    <mat-label>Select Prant : *</mat-label>
                    <mat-select formControlName="prant_id" required>
                        <mat-option *ngFor="let item of prantData" value="{{ item['id'] }}">{{ item["prant_name"] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-group" style="padding-bottom: 20px;">
                <button style="width: 60%; margin-left: 20%; margin-top: 3%;" [disabled]="districtForm.invalid"
                    class="btn btn-info">Update</button>
            </div>
        </form>
    </div>
</div>